/**
 * Created by fers on 24/04/2017.
 */

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import {safeJSONparse} from "../../common/util/safeJSONparse";
import ChannelOptionEdit from './ChannelOptionEdit.react';
import ChannelAddStep3 from './ChannelAddStep3.react';
import ChannelAddStep4 from './ChannelAddStep4.react';
import ChannelAddStep5 from './ChannelAddStep5.react';

// eslint-disable-next-line max-params
export function getUrlForChannelCreate(organisation, channel, channelDef, scenario) {
    let metadata = safeJSONparse(channelDef.metadata);

    let args = {
        id: channel['id'],
        organisation_id: organisation['realId']
    };

    /* are we creating this channel as part of scenario? */
    let scenarioPrefix = "";
    if (scenario) {
        args['scenario_id'] = scenario['realId'];
        scenarioPrefix = "scenario-";
    }

    if (metadata.hasOptionsOnCreate) {
        let path = urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-2", args);
        return path;
    } else if (metadata.hasGrant) {
        let path = urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-3", args);
        return path;
    } else if (metadata.hasOptionsAfterGrant) {
        let path = urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-4", args);
        return path;
    } else {
        let path = urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-5", args);
        return path;
    }
}

export function getComponentForChannelCreate(channelDef) {
	let metadata = safeJSONparse(channelDef.metadata);

	if (metadata.hasOptionsOnCreate) {
		return ChannelOptionEdit;
	}

	if (metadata.hasGrant) {
		return ChannelAddStep3;
	}

    if (metadata.hasOptionsAfterGrant) {
		return ChannelAddStep4;
	}

	return ChannelAddStep5;
}
